import { render, staticRenderFns } from "./NavbarChannelsDropdown.vue?vue&type=template&id=24fd3ae6&scoped=true&"
import script from "./NavbarChannelsDropdown.vue?vue&type=script&lang=js&"
export * from "./NavbarChannelsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavbarChannelsDropdown.vue?vue&type=style&index=0&id=24fd3ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd3ae6",
  null
  
)

export default component.exports